import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix for default marker icon issue in React-Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
});

// Custom HADEN marker icon (red)
const hadenIcon = new L.Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

// Novotel marker icon (blue)
const novotelIcon = new L.Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

// Airport marker icon (grey)
const airportIcon = new L.Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-grey.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

function LocationMap({ coordinates, className }) {
  const { lat, lng } = coordinates || { lat: 17.2529, lng: 78.4743 };
  
  // RGIA Airport coordinates
  const airportCoords = { lat: 17.2403, lng: 78.4294 };
  
  // Novotel Hyderabad Airport coordinates (between airport and HADEN)
  const novotelCoords = { lat: 17.2466, lng: 78.4520 };
  
  // Center the map to show HADEN, Novotel, and give context of airport proximity
  const centerLat = lat;
  const centerLng = lng;

  return (
    <div className={`relative w-full ${className}`} style={{ minHeight: '400px', zIndex: 1 }}>
      <MapContainer
        center={[centerLat, centerLng]}
        zoom={12}
        scrollWheelZoom={false}
        style={{ height: '100%', width: '100%', minHeight: '400px', borderRadius: '0.5rem' }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        
        {/* HADEN Systems Marker */}
        <Marker position={[lat, lng]} icon={hadenIcon}>
          <Popup>
            <div className="text-center">
              <strong className="text-base" style={{ color: '#101957' }}>HADEN Systems</strong>
              <br />
              <span className="text-sm text-gray-600">Plot No. 8B, Hardware Park</span>
              <br />
              <a 
                href={`https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 text-sm hover:underline"
              >
                Get Directions →
              </a>
            </div>
          </Popup>
        </Marker>
        
        {/* Novotel Marker */}
        <Marker position={[novotelCoords.lat, novotelCoords.lng]} icon={novotelIcon}>
          <Popup>
            <div className="text-center">
              <strong className="text-base text-blue-900">Novotel Hyderabad Airport</strong>
              <br />
              <span className="text-sm text-gray-600">Landmark en route from airport</span>
            </div>
          </Popup>
        </Marker>
        
        {/* RGIA Airport Marker */}
        <Marker position={[airportCoords.lat, airportCoords.lng]} icon={airportIcon}>
          <Popup>
            <div className="text-center">
              <strong className="text-base text-gray-800">✈️ Rajiv Gandhi International Airport</strong>
              <br />
              <span className="text-sm text-gray-600">RGIA - Shamshabad</span>
              <br />
              <span className="text-xs text-gray-500">~7 km from HADEN Systems</span>
            </div>
          </Popup>
        </Marker>
      </MapContainer>
      
      {/* Get Directions Button */}
      <div className="absolute bottom-4 right-4 z-[1000]">
        <a
          href={`https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`}
          target="_blank"
          rel="noopener noreferrer"
          className="px-4 py-2 bg-white rounded-lg shadow-lg text-sm font-medium hover:bg-gray-50 transition-colors flex items-center gap-2"
          style={{ color: '#101957' }}
        >
          <span>🚗</span> Get Directions
        </a>
      </div>
    </div>
  );
}

export default LocationMap;
